var getQueryParam = function (qname) {
    var params = decodeURIComponent(window.location.search).match(new RegExp("[?&]".concat(qname, "=([^&#]*)")));
    return params && params.length > 1 ? params[1] : '';
};
export default getQueryParam;
